import {Component} from '@angular/core';

@Component({
    selector: 'tpc-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app works!';
}



// WEBPACK FOOTER //
// ./src/app/components/app.component.ts